import { IRouteConfig } from "../../../helpers/route-config";

export const questionsUnanswered = (answers: {}) => {
    let errorCount = 0;
    Object.entries(answers).forEach(
        ([key, value]) => {
            if (
                key !== "id" &&
                value === undefined ||
                (typeof (value) === 'boolean' && value === undefined) ||
                (typeof (value) === 'number' && value === -1) ||
                (key !== "reportToEmail" && (typeof (value) === 'string' && !value.trim()))
            ) {
                console.debug(`Key ${key} not set (${value})`);
                errorCount++;
            }
        }
    );
    return errorCount;
};

export interface ISelectOption {
    label: string;
    value: string;
    getRoute(): IRouteConfig;
    subitem?: boolean;
}